import { memo } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type ItemPickerGallerySectionHeaderProps = {
  isOpen: boolean;
  label: string;
  onToggle: () => void;
};

/**
 * Collapse-toggle header for a picker gallery section. Rendered inside a GalleryView header box,
 * which stretches it to the box height — so the spacing the old collapsible section carried as
 * margins is owned by the box geometry instead.
 */
export const ItemPickerGallerySectionHeader = memo(
  ({ isOpen, label, onToggle }: ItemPickerGallerySectionHeaderProps) => {
    return (
      <button
        aria-expanded={isOpen}
        className="flex items-center gap-1.5 rounded-2 font-bold ads:text-metadata text-10 text-gray-10 uppercase tracking-wide outline-none ads:hover:text-primary hover:text-gray-12 ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9"
        data-testid="ITEM_PICKER_SECTION_TOGGLE"
        onClick={onToggle}
        type="button"
      >
        {label}
        <ChevronDownIcon className={cn('shrink-0 transition-transform', !isOpen && '-rotate-90')} size="xs" />
      </button>
    );
  },
);

ItemPickerGallerySectionHeader.displayName = 'ItemPickerGallerySectionHeader';
